import { useContext } from "react";
import { SessionContext, type SessionState } from "./SessionContext";

export function useSession(): SessionState {
  const context = useContext(SessionContext);
  if (context === undefined) {
    throw new Error("useSession must be used within a SessionProvider");
  }
  return context;
}
